import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { DomainPrebidStackDTO } from '../types/domainPrebidStackDTO'

export const DOMAIN_PREBID_STACK_FRAGMENT: TypedDocumentNode<DomainPrebidStackDTO> = gql`
  fragment DomainPrebidStackFragment on DomainPrebidStack {
    allowActivitiesData
    auctionDelay
    customAuctionDelayEnabled
    createdAt
    customConsentManagementEnabled
    customizeAllowActivities
    customizeNonConsentTrafficMonetization
    customPrebidTimeoutEnabled
    domainAmazonEnabled
    domainId
    gdprTcfTimeout
    gdprTcfEnabled
    gppControlUsNat
    gppControlUsStates
    gppTimeout
    gppEnabled
    id
    monetizeNonConsentTraffic
    prebidStackEnabled
    prebidTimeout
    updatedAt
    usPrivacyCcpaTimeout
    usPrivacyCcpaEnabled
  }
`
